import { CriteriaFile } from '../domain/CriteriaFile'
import { ICriteriaFileRepository } from '../domain/repositories/ICriteriaFileRepository'

export class DownloadCriteriaFileUseCase {
    private criteriaFileRepository: ICriteriaFileRepository

    constructor(criteriaFileRepository: ICriteriaFileRepository) {
        this.criteriaFileRepository = criteriaFileRepository
    }

    async execute(
        groupId: number,
        criteriaId: number
    ): Promise<CriteriaFile> {
        return await this.criteriaFileRepository.download(groupId, criteriaId)
    }
}
